import { useEventSourceNotificationsListener } from './useEventSourceNotificationsListener';

export const EventSourceNotificationsListener = () => {
    useEventSourceNotificationsListener();

    return null;
};
